"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var Lot_model_1 = require("../model/Lot.model");
var HttpLotManagementService = /** @class */ (function () {
    function HttpLotManagementService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.idmCmsServiceUrlKey = 'cms-service-url';
        this.lotByIdPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/lots/", ""], ["", "/lots/", ""])), 'serviceUri', 'lotId');
        this.idmCmsServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.idmCmsServiceUrlKey));
    }
    HttpLotManagementService.prototype.loadLotById = function (lotId) {
        var _this = this;
        return this.idmCmsServiceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.lotByIdPath.replaceTemplate({
                'serviceUri': serviceUri,
                'lotId': lotId.toString()
            });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            var options = { headers: headers };
            return _this.http.get(url, options).map(function (response) {
                if (response) {
                    response = new Lot_model_1.Lot(response.lotId, response.minBid, response.startDate, response.endDate);
                }
                return response;
            });
        }));
    };
    HttpLotManagementService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpLotManagementService);
    return HttpLotManagementService;
}());
exports.HttpLotManagementService = HttpLotManagementService;
var templateObject_1;
//# sourceMappingURL=http-lot-management.service.js.map